import { render } from "./WCItemModifierAddToCartButton.vue?vue&type=template&id=731f5f9b"
import script from "./WCItemModifierAddToCartButton.vue?vue&type=script&lang=js"
export * from "./WCItemModifierAddToCartButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__